module.exports = __webpack_public_path__ + "fonts/fontello.8d4a4e6f.woff2";